import React from "react";
import { Col, Row } from "react-bootstrap";
const CorporateGeneric = (props) => {
    var _a, _b;
    return (React.createElement(Row, { className: `flexJustifySpaceBetween coroprateActionGeneric m-0 ${props.parentClass ? props.parentClass : ""}` },
        React.createElement(Col, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 1, className: "researchtag EncodeSans_10_500 flexCenter" }, "C"),
                React.createElement(Col, { xs: 10, className: "flexJustifySpaceBetween EncodeSans_14_600 txt_blackOne1 m-0 corporateGenericTitle" }, props.title)),
            props.corporateActions &&
                ((_a = props.corporateActions) === null || _a === void 0 ? void 0 : _a.resultList) &&
                ((_b = props.corporateActions) === null || _b === void 0 ? void 0 : _b.resultList.map((item, i) => {
                    if ((props === null || props === void 0 ? void 0 : props.limit) ? i < props.limit : true)
                        return (React.createElement(Row, { key: i, className: "EncodeSans_12_500 txt-gold m-0 pl-13" },
                            React.createElement(Col, { className: "p-0", xs: 5 }, item.event),
                            React.createElement(Col, { className: "p-0 txt_blackOne1 ml-9", xs: 6 }, item.value)));
                }))),
        React.createElement(Col, { className: "EncodeSans_12_500 txt-secondary-navy alignright corporate-view p-0" },
            "View ",
            React.createElement("span", { className: "edel-icon-arrow-right" }))));
};
export default CorporateGeneric;
